import React from 'react'

import { Button } from '@mui/material'

export default (props) => {
  const { history } = props
  function goBack() {
    history.goBack()
  }

  return (
    <div>
      404{' '}
      <Button variant="contained" type="button" onClick={goBack}>
        Voltar
      </Button>
    </div>
  )
}
